import * as React from 'react';
import FileProviderView from './FileProviderView';
import showFilePickerOption from './utils/showFilePickerOption';
import strings from 'owa-strings/owa-mail-strings';
import { ControlIcons } from 'owa-control-icons';
import { getAddableFileProviders } from 'owa-fileprovider-store/lib/selectors/getAddableFileProviders';
import { getIconForFileProvider as getAddProviderIconCSS } from 'owa-fileprovider-icon';
import { observer } from 'mobx-react';

const styles = require('./AddFileProviderView.scss');

@observer
export default class AddFileProviderView extends React.Component<{}> {
    render() {
        return (
            <div>
                {this.shouldShowAddAProviderView() && (
                    <FileProviderView
                        name={strings.AddAFileProvider}
                        icon={getAddProviderIconCSS(ControlIcons.Add, styles.icon)}
                        onClick={this.onAddProviderClicked}
                        ariaLabel={strings.AddAFileProvider}
                    />
                )}
            </div>
        );
    }

    // We only show the "Add a Provider" button when there is some provider that is addable that the user does not yet have.
    // Otherwise it would clutter the left nav, and clicking it would open an empty panel.
    private shouldShowAddAProviderView(): boolean {
        return getAddableFileProviders().length > 0;
    }

    private onAddProviderClicked = () => {
        showFilePickerOption();
    };
}
